import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiJson } from '../api/client.js';

export function AdminContactsPage() {
  const [searchParams] = useSearchParams();
  const [contacts, setContacts] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState(() => searchParams.get('q') || '');
  const ghlFilter = searchParams.get('ghl');

  useEffect(() => {
    const q = searchParams.get('q');
    if (q != null) {
      setSearch(q);
    }
  }, [searchParams]);

  useEffect(() => {
    apiJson('/api/admin/contacts')
      .then(setContacts)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const filtered = contacts.filter((c) => {
    if (ghlFilter === 'missing' && c.ghl_synced) return false;
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return [c.name, c.email, c.phone, c.address].some((v) => String(v || '').toLowerCase().includes(q));
  });

  return (
    <div>
      <h2 style={{ marginTop: 0 }} data-tour="page-title">Contacts</h2>
      <p className="muted small">Client contacts synced from your CRM (GoHighLevel).</p>
      {ghlFilter === 'missing' ? (
        <p className="muted small">Showing clients without GHL contact sync.</p>
      ) : null}
      <label className="field" style={{ maxWidth: '24rem' }}>
        <span>Search</span>
        <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Name, email, phone, address…" />
      </label>
      {loading ? <p className="muted">Loading…</p> : null}
      {error ? <p className="err">{error}</p> : null}
      {!loading && !filtered.length ? <p className="muted">No contacts found.</p> : null}
      <ul className="list-plain" data-tour="contacts-list">
        {filtered.map((c) => (
          <li key={c.id} className="auth-card flat" style={{ marginBottom: '0.75rem' }}>
            <div className="row-actions" style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <strong>
                  <Link to={`/admin/clients/${c.id}`}>{c.name}</Link>
                </strong>
                {!c.is_active ? <span className="muted small"> · inactive</span> : null}
                <div className="muted small">{c.email || 'No email'}</div>
                {c.phone ? <div className="muted small">{c.phone}</div> : null}
                {c.address ? <div className="muted small" style={{ whiteSpace: 'pre-wrap' }}>{c.address}</div> : null}
              </div>
              <span className={`badge ${c.ghl_synced ? 'badge-ok' : 'badge-warn'}`}>
                {c.ghl_synced ? 'GHL synced' : 'No GHL'}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
